import React from "react";
import Waiting from "../../game/waiting/waiting";
import { PlayerAction } from "../../../types";
import { GameStatus } from "../../../types/game-status";
import { useWaitableData } from "../../../hooks/useWaitableData";

type Props = {
  playerActionHandler?: (playerAction: PlayerAction) => void;
  waitingFor: GameStatus[];
  waitHeader: string;
  subHeader?: string;
  audienceOverride?: boolean;
  children?: React.ReactNode;
};

const Waitable: React.FunctionComponent<Props> = (props) => {
  const { shouldWait, skippyText, waitingPlayers, loading, countdown } =
    useWaitableData({
      waitingFor: props.waitingFor,
      audienceOverride: props.audienceOverride,
    });

  return (
    <>
      {shouldWait ? (
        <Waiting
          subHeader={props.subHeader || skippyText}
          players={waitingPlayers}
          header={props.waitHeader}
          onPlayerAction={props.playerActionHandler}
          loading={loading}
          countdown={countdown}
        />
      ) : (
        props.children
      )}
    </>
  );
};

export default Waitable;
